export function parseLeanSchemaRef(renderedSchemaName) {
    if (renderedSchemaName === void 0) { renderedSchemaName = ''; }
    var _a = getSchemaNameAndType(renderedSchemaName), typeOrName = _a[0], schemaName = _a[1];
    if (schemaName) {
        return {
            schemaName: schemaName,
            schemaType: typeOrName,
        };
    }
    return {
        schemaName: typeOrName,
    };
}
// if there is no type, returns only the name
var getSchemaNameAndType = function (leanSchema) { return leanSchema.split('#'); };
//# sourceMappingURL=utils.js.map